import cc from "classcat"
import LocalizedLink from "components/LocalizedLink"

export const TagList = ({ children }) => {
  return <ul className="mb-8 flex flex-wrap gap-2">{children}</ul>
}

export const TagCore = ({ current, children }) => {
  return (
    <div
      className={cc([
        "m-0 inline-flex items-center rounded-lg px-2 py-0.5 text-sm font-medium text-gray-800 transition-all hover:-translate-y-0.5 hover:shadow-md active:bg-kkm-green/70",
        current ? "bg-kkm-green/100" : "bg-kkm-green/30",
      ])}
    >
      {children}
    </div>
  )
}

export const Tag = ({ tag, to, children, current, ...rest }) => {
  return (
    <LocalizedLink to={to} {...rest}>
      <li key={tag} className="mb-0 list-none">
        <TagCore current={current}>{children}</TagCore>
      </li>
    </LocalizedLink>
  )
}
